// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-m7TW","importantInfo":"styles_importantInfo__3iObv"};